// extracted by mini-css-extract-plugin
export var form = "_4u-0";